<template>
	<nav class="edi-nav">
		<!-- <a class="edi-nav-back"></a> -->
		{{title}}
	</nav>
</template>
<script>
export default {
	props: {
		title: String
	}
}
</script>


// WEBPACK FOOTER //
// NavBar.vue?e202de42